// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 53 ? "webfontloader" : chunkId) + "." + {"53":"f7e2086b","731":"e914a597","979":"7aef07ce"}[chunkId] + ".js";
};